let audio: AudioContext | null = null;

function contexteAudio(): AudioContext | null {
  try {
    const Contexte =
      globalThis.AudioContext ??
      (globalThis as typeof globalThis & { webkitAudioContext?: typeof AudioContext })
        .webkitAudioContext;
    if (!Contexte) return null;
    audio ??= new Contexte();
    if (audio.state === 'suspended') void audio.resume();
    return audio;
  } catch {
    return null;
  }
}

/** À appeler depuis un geste (le clic qui active la caméra) : Safari refuse sinon de jouer le bip. */
export function preparerSon(): void {
  contexteAudio();
}

/** Le bip et la vibration d'une œuvre ajoutée au panier. Silencieux là où le navigateur ne les offre pas. */
export function signalerLecture(): void {
  try {
    navigator.vibrate?.(30);
  } catch {
    /* Vibration refusée par le navigateur. */
  }
  try {
    const contexte = contexteAudio();
    if (!contexte) return;
    const oscillateur = contexte.createOscillator();
    const gain = contexte.createGain();
    oscillateur.frequency.value = 880;
    gain.gain.setValueAtTime(0.15, contexte.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.001, contexte.currentTime + 0.12);
    oscillateur.connect(gain).connect(contexte.destination);
    oscillateur.start();
    oscillateur.stop(contexte.currentTime + 0.12);
  } catch {
    /* Pas de son : le retour visuel suffit. */
  }
}
